import { db, META_KEYS } from './index';

async function get(key) {
  const row = await db.meta.get(key);
  return row?.value;
}

async function set(key, value) {
  await db.meta.put({ key, value });
}

function uuid() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2)}`;
}

export const metaRepo = {
  async getAnonUserId() {
    return get(META_KEYS.ANON_USER_ID);
  },

  async ensureAnonUserId() {
    const existing = await get(META_KEYS.ANON_USER_ID);
    if (existing) return existing;
    const id = `anon-${uuid()}`;
    await set(META_KEYS.ANON_USER_ID, id);
    return id;
  },

  async getActiveUserId() {
    return get(META_KEYS.ACTIVE_USER_ID);
  },

  async setActiveUserId(userId) {
    await set(META_KEYS.ACTIVE_USER_ID, userId);
  },

  async getLastSyncAt() {
    return get(META_KEYS.LAST_SYNC_AT);
  },

  async setLastSyncAt(iso) {
    await set(META_KEYS.LAST_SYNC_AT, iso);
  },

  async isAnonBannerDismissed() {
    return (await get(META_KEYS.ANON_BANNER_DISMISSED)) === true;
  },

  async dismissAnonBanner() {
    await set(META_KEYS.ANON_BANNER_DISMISSED, true);
  },

  async getOnboardedAt() {
    return get(META_KEYS.ONBOARDED_AT);
  },

  async markOnboarded() {
    await set(META_KEYS.ONBOARDED_AT, new Date().toISOString());
  },
};
